module.exports = {
      id: "comm-automobile-usage",
      viewBox: "0 0 231.941 38.7",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#comm-automobile",
      toString: function () {
        return this.url;
      }
    }